import {createSelector, createFeatureSelector} from '@ngrx/store';
import {PaperChatState} from './paper-chat.reducer';
import {PaperChatFilterType} from '../dto/paper-chat';
import {selectQueryParam} from '../../../utils/services/router.selectors';

// Feature Selector
export const selectPaperChatFeature = createFeatureSelector<PaperChatState>('paperChat');

// Select Messages by Project
export const selectMessagesByProject = createSelector(
  selectPaperChatFeature,
  (state: PaperChatState) => state.messages
);

// Select Messages for a Specific Project
export const selectMessagesForProject = (projectId: number) =>
  createSelector(
    selectMessagesByProject,
    (messagesByProject) => messagesByProject
      .filter(message => message.projectId === projectId)
      .sort((a, b) => a.timestamp - b.timestamp) || []
  );
// Select Connected Status by Project
export const selectConnectedByProject = createSelector(
  selectPaperChatFeature,
  (state: PaperChatState) => state.connectedByProject
);

// Select Connected Status for a Specific Project
export const selectConnectedForProject = (projectId: number) =>
  createSelector(
    selectConnectedByProject,
    (connectedByProject) => connectedByProject[projectId] || false
  );

// Select Errors by Project
export const selectErrorByProject = createSelector(
  selectPaperChatFeature,
  (state: PaperChatState) => state.errorByProject
);

// Select Error for a Specific Project
export const selectErrorForProject = (projectId: number) =>
  createSelector(
    selectErrorByProject,
    (errorByProject) => errorByProject[projectId] || null
  );


// Select FilterType
export const selectFilterType = () =>
  createSelector(
    selectPaperChatFeature,
    (state) => {
      return state.filterType || PaperChatFilterType.ALL;
    }
  );

export const selectSelectedQueryParam = () =>
  createSelector(
    selectQueryParam("paper"),
    (state) => {
      return typeof state === 'string' ? state : undefined;
    }
  );




